<template>
  <div
    class="commit-item-box pa-3 mb-2 rounded-xl d-flex align-center justify-space-between flex-wrap ga-2"
  >
    <div class="d-flex align-center flex-grow-1 mr-2" style="min-width: 0">
      <v-avatar color="var(--brand-soft)" size="26" class="mr-3 flex-shrink-0">
        <v-icon x-small color="var(--brand)">mdi-source-commit</v-icon>
      </v-avatar>

      <span
        class="commit-hash-pill px-2 py-1 rounded-md mr-3 font-monospace flex-shrink-0"
        :title="'Hash do commit: ' + commit.hash"
      >
        {{ commit.hash_curto || formatHash(commit.hash) }}
      </span>

      <v-chip
        v-if="commit.escopo"
        x-small
        color="var(--brand-soft)"
        text-color="var(--brand)"
        class="font-weight-bold mr-2 text-lowercase flex-shrink-0"
      >
        <v-icon left x-small>mdi-label-outline</v-icon>
        {{ commit.escopo }}
      </v-chip>

      <v-chip
        v-if="commit.branch && commit.branch !== 'main'"
        x-small
        color="var(--ci-tint-azul)"
        text-color="var(--ci-tint-azul-texto)"
        class="font-weight-bold mr-2 text-lowercase flex-shrink-0"
      >
        <v-icon left x-small>mdi-git</v-icon>
        {{ commit.branch }}
      </v-chip>

      <span class="commit-msg-text font-weight-medium text-truncate">
        {{ commit.mensagem }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommitItem",
  props: {
    commit: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatHash(hash) {
      if (!hash) return "0000000";
      return hash.length > 7 ? hash.substring(0, 7) : hash;
    },
  },
};
</script>

<style scoped>
.commit-item-box {
  --ci-borda-hover: #cbd5e1;
  --ci-hash-fundo: #1e293b;
  --ci-hash-texto: #f8fafc;
  --ci-tint-azul: #e3f2fd;
  --ci-tint-azul-texto: #1d4ed8;
  background-color: var(--surface);
  border: 1px solid var(--border-soft);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03);
  transition: all 0.2s ease;
}

.theme--dark .commit-item-box {
  --ci-borda-hover: #4a4458;
  --ci-hash-fundo: #3a3450;
  --ci-hash-texto: var(--text);
  --ci-tint-azul: rgba(59, 130, 246, 0.16);
  --ci-tint-azul-texto: #93c5fd;
}

.commit-item-box:hover {
  background-color: var(--surface-2);
  border-color: var(--ci-borda-hover);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.commit-hash-pill {
  background-color: var(--ci-hash-fundo);
  color: var(--ci-hash-texto);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.font-monospace {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace !important;
}

.commit-msg-text {
  color: var(--text);
  font-size: 0.88rem;
  line-height: 1.4;
}
</style>
